import React from 'react'

interface buttonProps{
    id?: string,
    name?: string,
    disabled?: boolean
}

export default function Button(props: buttonProps) {

    if(props?.id){
        if(props?.name){
            return <button type='submit'>Update</button>
        }
        else{
            return <div></div>;
        }
    }
    else{
        return <button className='saveBtn' type='submit' disabled={props?.disabled}>Save</button>
    }
}
